import React from "react";

import { StyledButton } from "./Button.styles";

const Button = ({ children }) => {
  return <StyledButton>{children}</StyledButton>;
};

export default Button;
